import { render, staticRenderFns } from "./CorporationGroup.vue?vue&type=template&id=65cd8906"
import script from "./CorporationGroup.vue?vue&type=script&lang=js"
export * from "./CorporationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports